import React, { useEffect, useState } from "react";
import { loadAssetProjectInfo } from "@10x/dubai-rest-api/dist/property_registry/api";
import { AssetProjectInfoResponse, PropertyProjectInfo } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { DetailsKV } from "@my-dld/screens/MyDLD/PropertyDetails";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";

export function ProjectInfo( props: { propertyId: number } ) {
	const { propertyId } = props;
	const [ info, setInfo ] = useState<PropertyProjectInfo | undefined>( undefined );
	useEffect( () => {
		loadAssetProjectInfo( propertyId ).then( ( response: AssetProjectInfoResponse ) => {
			if ( response && response.response && response.response.propertyProjectInfo ) {
				const info = response.response.propertyProjectInfo;
				if ( info.projectNumber && info.projectNumber !== 0 ) {
					setInfo( info );
				}
			}
		} ).catch( e => {
			console.log( e );
		} );
	}, [ propertyId ] );

	if ( info )
		return <>
			<DetailsKV
				label={ Strings.project_number }
				value={ info.projectNumber }/>
			{ info.projectName && <DetailsKV
				label={ Strings.Project_Name_Label }
				value={ LocaleUtil.getLocalValue( info.projectName ) }/> }
		</>;
	return null;
}
